import { Card, CardContent } from "../../ui/card";
interface Logo {
  name: string;
  imageUrl: string;
}

interface LogoGridProps {
  data: {
    title?: string;
    logos: Logo[];
  };
}

export const LogoGrid = ({ data }: LogoGridProps) => {
  return (
    <Card className="my-8">
      <CardContent className="p-6">
        {data.title && (
          <h3 className="text-lg font-semibold text-neutral-900 mb-6">{data.title}</h3>
        )}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-center justify-items-center">
          {data.logos.map((logo, idx) => (
            <div key={idx} className="w-full flex items-center justify-center group">
              <img 
                src={logo.imageUrl} 
                alt={logo.name} 
                className="max-h-12 max-w-full object-contain opacity-60 grayscale group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                title={logo.name}
              />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
